import { PUT_CURRENT_LANGUAGE } from '../../reducers/constants';

const putCurrentLanguage = (currentLanguage) => ({
  type: PUT_CURRENT_LANGUAGE,
  currentLanguage,
});
export default putCurrentLanguage;
